module.exports = __webpack_public_path__ + "3c9dffb3bcb228534e8d42396b5c8f1c.MP3";